import {GetTitleResponse} from '@app/titles/requests/use-title';
import {apiClient} from '@common/http/query-client';

const titleCache: Record<string, GetTitleResponse> = {};

export function getTitle(titleId: number | string, loader: string) {
  if (titleCache[titleId]) {
    return Promise.resolve(titleCache[titleId]);
  }

  return apiClient
    .get<GetTitleResponse>(`titles/${titleId}`, {params: {loader}})
    .then(response => {
      titleCache[titleId] = response.data;
      return response.data;
    });
}
